import React from "react";

const Loader = ({ size = 40, color = "#3498db" }) => {
  return (
    <div className="loader-container">
      <div
        className="loader-spinner"
        style={{
          width: size,
          height: size,
          borderColor: `${color} transparent transparent transparent`,
        }}
      ></div>
    </div>
  );
};

export default Loader;
